import {Scan} from "@/types/Scan";
import {endpoint} from "@/utils/api/Conf";

export const walkGeoRequest = async (authToken: string, locale: string, latitude?: string, longitude?: string,) => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
        "X-Language": locale || "it"
      },
    }
    const jsonFetch = await fetch(endpoint + `walk/geo?latitude=` + latitude + '&longitude=' + longitude, init)
    return await jsonFetch.json().then((response) => {
      return response.actions as Scan[]
    })

  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
